import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { wrapRootElement as wrapRootElementBase } from './src/shopify/wrap-root-element'

export const wrapRootElement = ({ element }) => (
  <HelmetProvider>{wrapRootElementBase({ element })}</HelmetProvider>
)
